

export class EmployeeWorkingDays implements IEmployeeWorkingDays {
    employeeId!: number | undefined;
    workingDay!: number | undefined;
    presentDay!: number;
    absentDay!: number;

    constructor(data?: IEmployeeWorkingDays) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeId = _data["employeeId"];
            this.workingDay = _data["workingDay"];
            this.presentDay = _data["presentDay"];
            this.absentDay = _data["absentDay"];
        }
    }

    static fromJS(data: any): EmployeeWorkingDays {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeWorkingDays();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeId"] = this.employeeId;
        data["workingDay"] = this.workingDay;
        data["presentDay"] = this.presentDay;
        data["absentDay"] = this.absentDay;
        return data; 
    }
}

export interface IEmployeeWorkingDays {
    employeeId: number | undefined;
    workingDay: number | undefined;
    presentDay: number;
    absentDay: number;
}

